
import { i18nText } from '@/locales';
export const TestRoutes = [
    {
        path: "/tests",
        redirect: "/tests/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            auth: true,
        },
        children: [
            {
                path: "payment",
                meta: {
                    title: i18nText("Услуги - EPILIER"),
                },
                name: "Test Visitpayments",
                component: (): any => import("@/UI/components/forms/visits/detail/VisitPayment.vue"),
                //visit_id - 146, client_id - 54

                props: { visit_id: 146, client_id: 54 },
            },

            {
                path: "complete",
                meta: {
                    title: "Complete",
                },
                name: "Complete",
                component: (): any => import("@/UI/pages/Test/complete.vue"),
            },
        ],
    },
];
